<template>
    <div class="social-media-page">
      <div class="loading-spinner-outer" v-if="saving_file && saving_file_number > 0">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Uploading file {{ saving_file_number }} of {{ attachments.length }}, please wait
          </div>
        </div>
      </div>
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Photography Services From Epwin
                </div>
                <div class="logo">
                    <img src="/images/powered-by-logo-epwin.png">
                </div>
            </div>
            <div class="box-1">
                <h1>
                    Get FREE Professional Photography
                </h1>
                <p>
                  Do you have a stunning installation that you would love to get some FREE professional photography of?
                </p>
                <p>
                  Submit an image, location and a brief description of the project.
                </p>
                <div>
                    <a class="btn-primary _lg" @click.prevent="enquiry_box_open = true">
                        Make Enquiry
                    </a>
                </div>
            </div>
            <div class="overlapping-image">
                <img src="/images/photography-page-image-1.png">
            </div>
            <div class="box-2">
                <p>
                    <a class="btn-primary-outline _lg" @click.prevent="enquiry_box_open = true">
                        Make Enquiry
                    </a>
                </p>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Photography Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                      Submit an image, location and a brief description of the project.
                    </div>
                  <div class="form-group">
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                  </div>
                  <div class="form-group h-full flex flex-col">
                    <label>Upload Images</label>
                    <form :action="`${$aws_upload_url}`" method="post"
                          enctype="multipart/form-data" id="amazon_form">
                      <input type="hidden" name="policy" :value="aws_policy">
                      <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                      <input type="hidden" name="x-amz-credential" :value="aws_credential">
                      <input type="hidden" name="x-amz-date" :value="aws_date">
                      <input type="hidden" name="x-amz-signature" :value="aws_signature">
                      <input type="hidden" name="acl" value="private">
                    </form>
                    <vue-dropzone
                        ref="fileUploadDropzone"
                        id="dropzone"
                        :options="dropzoneOptions"
                        v-on:vdropzone-file-added="fileAddedToDropZone"
                        v-on:vdropzone-removed-file="fileRemovedFromDropZone"
                        :useCustomSlot="true"
                    >
                      <div>
                        <div class="mb-3">
                          DRAG AND DROP FILE
                        </div>
                        <div class="mb-3">
                          OR
                        </div>
                        <div>
                          <a class="btn-secondary-outline">
                            Choose a file
                          </a>
                        </div>
                      </div>
                    </vue-dropzone>
                  </div>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiryMessage()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";

export default {
    props: [
        'logged_in_user',
      'aws_policy',
      'aws_credential',
      'aws_date',
      'aws_signature'
    ],
    data() {
        return {
          enquiry_box_open: false,
          enquiry_message: '',
          sending: false,
          saving_file: false,
          uploaded_file: null,
          attachments: [],
          attachment_info: [],
          saving_file_number: 0,
          dropzoneOptions: {
            url: '/',
            autoProcessQueue: false,
            uploadMultiple: true,
            addRemoveLinks: true,
          },
        }
    },
    components: {
      'vue-dropzone': vue2Dropzone,
    },
    methods: {
      fileAddedToDropZone(uploadedFile) {
        const extension = uploadedFile.name.replace(/^.*\./, '');
        const original_file_name = uploadedFile.name.replace('.' + extension, '');

        let new_upload = {};

        new_upload.name = original_file_name;
        const filename = 'enquiry_attachments/' + original_file_name + '_' + Date.now();
        new_upload.filename = filename + '.' + extension;

        if (extension.toLowerCase() === 'svg') {
          new_upload.thumbnail_url = new_upload.filename;
        } else {
          new_upload.thumbnail_url = 'thumbnails/' + filename + '.png';
        }

        new_upload.filetype = uploadedFile.type;
        new_upload.uploaded_file = uploadedFile;
        new_upload.original_file_name = original_file_name;
        new_upload.file_url = filename;

        this.attachments.push(new_upload);
        this.attachment_info.push({
          original_file_name: original_file_name,
          filename: filename + '.' + extension,
        });
      },
      fileRemovedFromDropZone(file) {
        const extension = file.name.replace(/^.*\./, '');
        const original_file_name = file.name.replace('.' + extension, '');
        this.attachments = this.attachments.filter(attachment => attachment.original_file_name !== original_file_name);
        this.attachment_info = this.attachment_info.filter(attachment => attachment.original_file_name !== original_file_name);
      },
        sendEnquiry() {
          this.saving_file = false;
          this.saving_file_number = 0;
          this.sending = true;
          axios.post('/enquiry/send', {
            enquiry_type_id: 24,
            message: this.enquiry_message,
            attachments: this.attachment_info,
          }).then((response) => {
            this.enquiry_message = '';
            this.sending = false;
            this.$refs.fileUploadDropzone.dropzone.removeAllFiles();
            this.attachments = [];
            this.attachment_info = [];

            gtag('event', 'enquiry_made', {
              'event_category': 'enquiries',
              'event_label': 'Photography enquiry',
              'value': 'Photography enquiry',
            });

            Swal.fire({
              title: 'Enquiry Sent',
              icon: 'success',
              text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
            });

          });
        },
      async sendEnquiryMessage() {

        if (this.enquiry_message === '') {
          Swal.fire({
            title: 'Please enter a message',
            icon: 'error',
          });
          return;
        }

        if (this.attachments.length < 1) {
          Swal.fire({
            title: 'Please upload some images',
            icon: 'error',
          });
          return;
        }

        this.enquiry_box_open = false;
        this.saving_file_number = 1;

        await this.attachments.forEach(async (upload, index) => {
          let form_data = new FormData(document.querySelector('#amazon_form'));
          form_data.append('Content-Type', upload.filetype);
          form_data.append('key', upload.filename);
          form_data.append('file', upload.uploaded_file);

          await axios({
            method: 'post',
            url: this.$aws_upload_url,
            data: form_data,
            headers: {'Content-Type': 'multipart/form-data'}
          }).then(async () => {

            if(this.saving_file_number === this.attachments.length) {
              this.sendEnquiry();
            } else {
              this.saving_file_number = this.saving_file_number + 1;
            }

          });
        });

      },
    },
};
</script>
